const html = `
<div>

<div class=WordSection1>

<p class=MsoAbnormal align=center style='text-align:center;line-height:115%'><b><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Aviso
de Privacidad Wirebit</span></b></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%'><span lang=ES-MX
style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> De acuerdo con la
"Ley Federal de Protección de Datos Personales en Posesión de los Particulares”, “WIREBIT”
declara ser una empresa constituida legalmente y es responsable del trato de sus datos personales,
por la presente le informa que la información proporcionada por nuestros clientes a través de diferentes
formularios, Registro de Usuario en el Sistema, Solicitud de Información, Adquisición de Servicios,
entre otros formularios que podrán integrarse en el futuro; serán tratados de forma estrictamente confidencial,
por lo que al proporcionar sus datos personales, tales como: 1. Nombre/Razón social. 2. Dirección.
3. Registro Federal de Contribuyentes. 4. Oficina y teléfonos celulares 5. Correo electrónico.
6. Información bancaria. Estos serán utilizados única y exclusivamente para los siguientes fines:
1. Campañas Publicitarias. 2. Campañas de Lealtad. 3. Información y Prestación de Servicios.
4. Actualización de la Base de Datos. 5. Cualquier finalidad análoga o compatible con las anteriores.
Para evitar el acceso no autorizado a sus datos personales y con el fin de asegurar que la información
sea utilizada para los fines establecidos en el presente aviso de privacidad, hemos establecido diversos
procedimientos con el fin de evitar el uso o divulgación no autorizada de sus datos, permitiéndonos tratarlos
adecuadamente. Asimismo, le informamos que sus datos personales podrán ser transmitidos para ser tratados por
otras personas. Todos sus datos personales son tratados de conformidad con la legislación aplicable vigente en
el país, por lo que le informamos que tiene en todo momento los derechos de acceso, rectificación, cancelación
u oposición al tratamiento que le damos a sus datos personales; derecho que puede hacer valer a través del Área
de Privacidad responsable de la seguridad de los datos personales en el correo electrónico info@wirebit.com y
a través de este sitio web www.wirebit.com puede actualizar sus datos y especificar el medio por el cual desea
recibir información. El presente aviso de privacidad podrá ser modificado por “WIREBIT”, dichas modificaciones
serán debidamente informadas a través de correo electrónico, teléfono, página web o cualquier otro medio de
comunicación determinado para esta propósito.</span></p>

<br><br>

<p class=MsoAbnormal align=center style='text-align:center;line-height:115%'><b><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Aviso
de Privacidad Wirebit</span></b></p>




<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:
"Arial",sans-serif'>WIREBIT S.A.P.I DE C.V.</span></b><span lang=ES-MX
style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> (en lo
sucesivo “<b>WIREBIT</b>”), con domicilio en Prolongación los Soles, entre
calle Humberto Junco Voigh y Cristóbal Colón, T3, PH-01-B, San Pedro Garza
García, Nuevo León, C.P. 66269, por este conducto y con la finalidad de dar
cumplimiento a lo establecido por la Ley Federal de Protección de Datos
Personales en Posesión de los Particulares (en adelante la Ley), WIREBIT<b> </b>proporciona
el presente Aviso de Privacidad para informarle la forma en que recabamos,
transferimos, almacenamos y utilizamos los datos personales, bajo los principios
de licitud, consentimiento, información, calidad, finalidad, lealtad,
proporcionalidad y responsabilidad.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:14.2pt;text-align:justify;text-indent:-14.2pt;line-height:115%;
border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>I.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Finalidad del Tratamiento de datos.</span></b></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:14.2pt;text-align:justify;line-height:115%;border:none'><b><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>WIREBIT es responsable de recabar,
tratar y proteger los datos personales, con la finalidad de a) Verificar la
identidad de sus clientes y la veracidad de la información que proporcionen
como propia; b) Formalizar una relación contractual entre el cliente y WIREBIT
con la finalidad de prestar los servicios contratados conforme a lo pactado
entre las partes; c) Integrar expedientes y bases de datos de sus clientes, ya
sea directamente por WIREBIT o a través de un tercero y reportar a las
autoridades competentes dicha información cuando así lo establezcan las
disposiciones legales vigentes; d) Ofrecer a sus clientes una ampliación o
mejora de los productos o servicios contratados; e) Ofrecer beneficios,
promociones o descuentos a sus clientes, y entre otras finalidades que WIREBIT
determine dentro de sus políticas con motivo de la relación contractual y/o
comercial que en su caso llegare a tener con sus clientes.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Además de las finalidades
generalizadas en el párrafo anterior, es importante que el cliente comprenda
que WIREBIT requiere la recopilación de esta información con la finalidad de
realizar actividades inherentes a los servicios contratados, como lo son:</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Proveer de hardware y software
relacionado con los servicios contratados.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Poder realizar las transacciones en
favor sus clientes.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Enviar vouchers, estados de cuenta,
desglose de las transacciones, pagos y facturas.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Brindar soporte y asesoría
relacionada con los servicios contratados.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Proveer de información o materiales
mercadotécnicos y publicitarios.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>f)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Creación, integración,
actualización y conservación del expediente de sus clientes.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>II.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Recopilación de datos.</span></b></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;line-height:115%;border:none'><b><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Los datos personales podrán ser
recabados por WIREBIT directamente, por un tercero o mediante otras fuentes
permitidas por la Ley y se tratarán con la finalidad exclusiva de realizar y
dar seguimiento al proceso de contratación de los clientes a WIREBIT por
cualquier producto y/o servicio que este último proporcione.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'> </span></p>

<p class=MsoAbnormal style='text-align:justify;line-height:115%'><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Los
clientes proporcionarán la información al momento de iniciar el proceso de
contratación mencionado en el párrafo anterior y al suscribir el presente
Aviso, así como al momento de modificar la información entregada a WIREBIT. Los
datos personales que se recopilarán son los siguientes:</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>(i)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Datos de Identificación</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>(ii)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Datos de Contacto</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>(iii)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Datos Informáticos</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>(iv)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Datos de Geolocalización</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>(v)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Datos Laborales</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>(vi)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Datos Comerciales</span></p>

<p class=MsoAbnormal style='margin-left:.75in;text-align:justify;text-indent:
-.5in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
line-height:115%;font-family:"Arial",sans-serif;color:black'>(vii)<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Datos financieros y/o
patrimoniales.</span></p>

<p class=MsoAbnormal style='text-align:justify'><span lang=ES-MX
style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>De manera automática, también se recolecta información acerca de
su uso de los sitios y servicios mediante cookies, contadores de visitantes,
java script, archivos de registro, píxeles y otra tecnología, que pueden incluir:
su nombre de dominio, tipo de buscador, preferencia de idioma del buscador,
tipo de dispositivo y sistema operativo, visitas a la página y vínculos en los
que usted hace clic dentro de los sitios, direcciones IP, identificación de
dispositivo u otro identificador, información de ubicación, indicación de fecha
y hora y tiempo que utilizó los Servicios, URL referido y su actividad dentro
de los sitios.</span></p>

<p class=MsoAbnormal style='text-align:justify'><span lang=ES-MX
style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>De forma enunciativa más no limitativa, se señala a continuación
información que recabará WIREBIT de los clientes:</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:38.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Personas Físicas:</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Nombre y apellidos.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Edad.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Género.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Dirección de correo electrónico.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>e.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Teléfono celular.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>f.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Datos de identificación.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>g.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>RFC</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:38.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Personas Morales:</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Denominación o razón social</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Domicilio</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Correo electrónico</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Teléfono</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>e.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>RFC</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>f.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Nombre del Representante legal</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:74.65pt;text-align:justify;text-indent:-.25in;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>g.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Giro de comercio</span></p>

<p class=MsoAbnormal style='margin-left:74.65pt;text-align:justify;text-indent:
-.25in;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>h.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Volumen de operaciones</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:
"Arial",sans-serif;color:black'>En caso de que el cliente no proporcione la
información antes mencionada, WIREBIT podrá abstenerse de prestarle sus
servicios. El cliente manifiesta que los datos personales proporcionados a
WIREBIT son veraces y actualizados y se obliga a comunicar a WIREBIT cualquier
modificación a los datos personales proporcionados con la mayor brevedad
posible a través de los medios establecidos para ello por WIREBIT.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:
"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='text-align:justify'><span lang=ES-MX
style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>Los datos que recabe WIREBIT directamente del cliente, serán
recabados a través de los Medios Electrónicos que se pongan a disposición.
WIREBIT podrá realizar las investigaciones, obtener fotografías, realizar
entrevistas, y en general, realizar las acciones que considere necesarias a
efecto de comprobar por sí o a través de terceros contratados particularmente
para ello, la veracidad de los datos personales que les fueron proporcionados
por el cliente. </span></p>

<p class=MsoAbnormal style='text-align:justify;line-height:115%'><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'>El mismo tratamiento a que se refiere el presente Aviso, tendrán
los datos personales recabados en lo futuro, el cliente podrá ejercer en
cualquier momento su derecho de oposición, según lo establecido en el presente
Aviso.</span></p>

<p class=MsoAbnormal style='text-align:justify;line-height:115%'><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'>WIREBIT&nbsp;no solicita ninguna información que bajo
la&nbsp;Ley&nbsp;se entiendan como datos sensibles, tales como religión,
preferencias sexuales, opiniones políticas, entre otros. En&nbsp;WIREBIT apoyamos
y fomentamos la diversidad; prohibimos cualquier acto discriminatorio o la
solicitud de cualquier información que pudiera implicar un acto
discriminatorio.</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>III.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Tratamiento de Datos.</span></b></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='text-align:justify'><span lang=ES-MX
style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>El tratamiento de la información recabada por WIREBIT tendrá el
tratamiento necesario para la única finalidad señalada en el apartado I del
presente Aviso.</span></p>

<p class=MsoAbnormal style='text-align:justify'><span lang=ES-MX
style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif;
color:black'>Así mismo, de manera adicional y como finalidades secundarias, que
si bien no son necesarias para la relación jurídica entre WIREBIT y el cliente,
permitirán en su caso, proveer diversos servicios o productos adicionales, o
mejorar los ya prestados y proporcionados: (i) ofrecer beneficios, promociones
o descuentos al cliente que tengan por objeto incentivar o premiar el uso de
los productos o servicios que comercializa WIREBIT; y (iii) elaborar encuestas
de calidad y satisfacción, respecto de los productos contratados. </span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>En caso de que el cliente no desee
que sus datos personales sean tratados para los fines secundarios, deberá
manifestar su negativa a los datos de contacto de WIREBIT, señalados en el
presente Aviso.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>IV.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Transferencia de datos.</span></b></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;line-height:115%;border:none'><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>WIREBIT utiliza los datos
personales de sus clientes exclusivamente para los fines señalados en el
presente Aviso y los conserva por el período señalado en las disposiciones
legales aplicables. Con la aceptación del presente Aviso se entiende que el
cliente otorga su autorización para que WIREBIT transfiera sus datos personales
a terceros, ya sean mexicanos o extranjeros sin que para ello se requiera
recabar nuevamente su consentimiento. WIREBIT comparte y transfiere los datos
recopilados en los siguientes supuestos: </span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Noto Sans Symbols";color:black'>✔<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Esté prevista en una ley o tratado
en los que México sea parte; </span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Noto Sans Symbols";color:black'>✔<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>La transferencia sea efectuada a
sociedades subsidiarias o afiliadas bajo el control común de cualquiera de
WIREBIT o a una sociedad matriz o a cualquier sociedad del mismo grupo de
WIREBIT que opere bajo los mismos procesos y políticas internas; </span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Noto Sans Symbols";color:black'>✔<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Sea necesaria en razón de un
contrato celebrado o por celebrar en interés del cliente; </span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Noto Sans Symbols";color:black'>✔<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Sea necesaria o legalmente exigida
para la salvaguarda de un interés público, o para la procuración o administración
de justicia; </span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Noto Sans Symbols";color:black'>✔<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Sea precisa para el reconocimiento,
ejercicio o defensa de un derecho en un proceso judicial; y, </span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.25in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Noto Sans Symbols";color:black'>✔<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Sea precisa para el mantenimiento o
cumplimiento de una relación jurídica entre el cliente y WIREBIT.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>WIREBIT cumplirá en todo momento
con los principios de protección de los datos personales de conformidad con la
Ley y su reglamento, por lo cual exigirá el apego a la Ley de los terceros a
quienes transfiera los Datos personales y a adoptar las medidas necesarias para
su protección.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Los terceros y las entidades
receptores de datos personales asumirán las mismas obligaciones y/o
responsabilidades que el WIREBIT ha asumido con el cliente. </span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>V.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Derecho de acceso, rectificación,
cancelación u oposición. (Derechos ARCO)</span></b></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;line-height:115%;border:none'><b><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Los clientes serán responsables de
la exactitud, veracidad, autenticidad y vigencia de sus datos, asimismo podrán
en cualquier momento ejercer sus Derechos ARCO.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>ACCESO:</span></b><span lang=ES-MX
style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'> El cliente tiene derecho a acceder a sus datos personales que
obren en poder de WIREBIT, así como conocer el presente Aviso.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>RECTIFICACIÓN:</span></b><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'> El cliente puede solicitar a WIREBIT la rectificación de sus
datos personales en caso de que no estén actualizados, sean inexactos o estén
incompletos. Para ejercer este derecho, deberá entregar a WIREBIT la
documentación que acredite la rectificación solicitada de acuerdo con los datos
personales.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>CANCELACIÓN:</span></b><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'> El cliente puede solicitar el bloqueo y la eliminación de datos
personales de las bases de datos y registros de WIREBIT cuando considere que la
misma no está siendo utilizada adecuadamente o para los fines que dieron origen
a la relación jurídica, sin embargo WIREBIT no estará obligado a cancelar los
datos personales cuando: a) Se refiera a las partes de un contrato privado,
social o administrativo y sean necesarios para su desarrollo y cumplimiento; b)
Deban ser tratados por disposición legal; c) Obstaculice actuaciones judiciales
o administrativas vinculadas a obligaciones fiscales, la investigación y
persecución de delitos o la actualización de sanciones administrativas; d) Sean
necesarios para proteger los intereses jurídicamente tutelados del cliente; e)
Sean necesarios para realizar una acción en función del interés público; y, f)
Sean necesarios para cumplir con una obligación legalmente adquirida por el
cliente.  </span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Cuando los datos personales
hubiesen sido transmitidos con anterioridad a la fecha de rectificación o
cancelación y sigan siendo tratados por terceros, WIREBIT informará a los
terceros de dicha solicitud de rectificación o cancelación, para que proceda a
efectuarla también.  </span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>OPOSICIÓN:</span></b><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'> El cliente podrá oponerse al tratamiento de sus datos personales.
</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>El ejercicio de cualquiera de los
Derechos ARCO no impide el ejercicio de algún otro derecho. En caso de que el
cliente deseé ejercer alguno de sus derechos ARCO, deberá realizar dicha
solicitud mediante escrito al correo electrónico<a name="bookmark=id.gjdgxs"></a>
</span><span lang=ES-MX><a href="mailto:atencionacliente@wirebit.mx"><span
style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:#0563C1'>atencionacliente@wirebit.mx</span></a></span><span lang=ES-MX
style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'> dicha solicitud deberá contener al menos lo siguiente:</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>I.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>El nombre del cliente y domicilio u
otro medio para comunicarle la respuesta a su solicitud; </span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>II.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Los documentos que acrediten la
identidad o, en su caso, la representación legal del cliente; </span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>III.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>La descripción clara y precisa de
los datos personales respecto de los que se busca ejercer alguno de los derechos
antes mencionados, y </span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.75in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>IV.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Cualquier otro elemento o documento
que facilite la localización de los datos personales</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;text-indent:
.5in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
line-height:115%;font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>VI.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Datos recabados de Terceros por el
Cliente.</span></b></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>El cliente acepta y reconoce que,
en caso de llevar a cabo el tratamiento de datos personales de terceros, se
encuentra obligado en términos de la LFPDPPP a contar con su propio Aviso de
Privacidad que le permita legalmente recabar, almacenar, usar, transferir,
manejar y disponer de los datos personales y sensibles de sus propios clientes
(en lo sucesivo “Terceros”).</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Asimismo, el cliente se obliga a
establecer en su Aviso de Privacidad la autorización de sus clientes, que le
permita transferir los datos personales y sensibles de éstos en favor de
WIREBIT con la finalidad de que en WIREBIT podamos tratar tales datos
personales y sensibles para el cumplimiento de la prestación de servicios entre
WIREBIT y el cliente.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>El cliente será el único
responsable de cumplir con las obligaciones pactadas en el presente apartado,
por lo que en caso de que el cliente incumpla y que por éste incumplimiento
WIREBIT se vea afectado de manera directa o indirecta, el cliente se obliga a
sacar en paz y a salvo a WIREBIT, debiendo responder por cualquier daño o
perjuicio que pudiera surgir en perjuicio de éste.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Los datos personales recabados
podrán ser tratados con la finalidad de que el cliente pueda atender
requerimientos legales de autoridades competentes.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>VII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Modificaciones al Aviso de
Privacidad.</span></b></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='text-align:justify;line-height:115%'><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>WIREBIT
podrá hacer modificaciones al presente Aviso, en estricto apego a la Ley y su
reglamento, en caso de que se lleven a cabo dichas modificaciones, WIREBIT
pondrá a disposición del cliente la información sobre estas, así como el nuevo
Aviso de Privacidad mediante la plataforma, sitio web de WIREBIT o cualquier
otro medio que WIREBIT determine para tal efecto.</span></p>

<p class=MsoAbnormal style='text-align:justify;line-height:115%'><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>De
conformidad a lo establecido en el presente numeral, el cliente será
responsable de mantener su cuenta de correo electrónico, domicilio y otro dato
de localización para notificaciones actualizados y de cerciorarse de que las
notificaciones sean recibidas en un medio que sea revisado constantemente. En
caso de no recibir objeción por parte del cliente en un plazo de 10 días
posteriores a que el Aviso haya sido puesto a su disposición, se entenderá que
acepta los cambios que pueda sufrir el Aviso.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>VIII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:107%;
font-family:"Arial",sans-serif;color:black'>Aceptación.</span></b></p>

<p class=MsoAbnormal style='text-align:justify'><span lang=ES-MX
style='font-size:8.0pt;line-height:107%;font-family:"Arial",sans-serif'>Al
ponerse a disposición el presente Aviso de Privacidad y la no manifestación
oposición alguna por el cliente, se entenderá que el cliente otorga a WIREBIT
su consentimiento para llevar a cabo el tratamiento de los datos personales que
hubieran sido proporcionados y/o los que con motivo de alguna de las
finalidades establecidas en el presente proporcione en lo futuro.</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;text-indent:-.5in;line-height:115%;
border:none'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>IX.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Revocar Consentimiento.</span></b></p>

<p class=MsoAbnormal style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:.5in;text-align:justify;line-height:115%;border:none'><b><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'>&nbsp;</span></b></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>En todo momento, usted podrá
revocar el consentimiento que nos ha otorgado para el tratamiento de sus datos
personales, a fin de que dejemos de hacer uso de estos. Para ello, es necesario
que presente su solicitud en los términos mencionados para el ejercicio de los
Derechos ARCO. </span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;text-indent:
35.4pt;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
line-height:115%;font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>Si usted considera que su derecho
de protección de datos personales ha sido lesionado por alguna conducta de
nuestros empleados o de nuestras actuaciones o respuestas, presume que en el
tratamiento de sus datos personales existe alguna violación a las disposiciones
previstas en la Ley Federal de Protección de Datos Personales en Posesión de
los Particulares, podrá interponer la queja o denuncia correspondiente ante el
IFAI. Para mayor información visite el sitio web </span><span lang=ES-MX><a
href="http://www.ifai.org.mx"><i><span style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:#0563C1'>www.ifai.org.mx</span></i></a></span><i><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black'>.</span></i><span lang=ES-MX style='font-size:8.0pt;line-height:
115%;font-family:"Arial",sans-serif;color:black'> </span></p>

<p class=MsoAbnormal style='margin-bottom:0in;text-align:justify;line-height:
115%;border:none'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
font-family:"Arial",sans-serif;color:black'>&nbsp;</span></p>

<p class=MsoAbnormal style='text-align:justify;line-height:115%'><span
lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Fecha
última actualización: 01 de diciembre de 2021</span></p>

</div>

</div> `
export default html;
